import React, { FC, useContext } from 'react'
import Button from '../../../components/button/Button'
import { FormattedMessage } from 'react-intl'
import { ChevronRight } from '@mui/icons-material'
import { makeStyles } from 'tss-react/mui'
import { OffreModel } from '../types/OffreModel'
import { SelectionPaneContext } from '../../../components/selectionPane/components/SelectionPaneContext'
import { useNavigate } from 'react-router'
import links from '../../../enums/linksEnum'

interface BoutonSelectionnerProps {
	offre: OffreModel
}

const BoutonSelectionner: FC<BoutonSelectionnerProps> = (
	{
		offre
	}
) => {
	const { classes } = useStyles()
	const navigate = useNavigate()
	const { updateCurrentOffer, hasCurrentClient } = useContext(SelectionPaneContext)

	const selectOffer = () => {
		updateCurrentOffer(offre)
		if (hasCurrentClient) {
			navigate(links.PLANIFICATION_VISITE)
		}
	}

	return (
		<Button
			background="backgroundAccessibility"
			color="colorWhite"
			textStyle="text4"
			buttonStyle={classes.boutonStyle}
			onClick={() => selectOffer()}
			fullWidth
		>
			<FormattedMessage
				id="offre.caracteristiques.bouton.select"
				defaultMessage="Sélectionner cette offre"
				description="Bouton pour sélectionner une offre"
			/>
			<ChevronRight />
		</Button>
	)
}

const useStyles = makeStyles()(() => ({
	boutonStyle: {
		borderRadius: 25,
		whiteSpace: 'break-spaces'
	}
}))
export default BoutonSelectionner